/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersImportJobResponse } from '../../models/users-import-job-response';

export interface GetUsersImportStatus$Params {
  'Active-Tenant-Identifier': string;
  jobId: string;
}

export function getUsersImportStatus(http: HttpClient, rootUrl: string, params: GetUsersImportStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportJobResponse>> {
  const rb = new RequestBuilder(rootUrl, getUsersImportStatus.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('jobId', params.jobId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsersImportJobResponse>;
    })
  );
}

getUsersImportStatus.PATH = '/users-import/{jobId}';
